export var mapBooleanToInt = function (bool) { return (bool ? 1 : 0); };
